import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconNames } from '../../common/constants/icon-names';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { DateWithTimezoneComponent } from '../timezone/date-with-timezone.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { DISPLAY_DATE_FORMAT } from '../../common/constants/date-config';
import { LocalDate } from '../../store/models/local-date.model';

@Component({
  selector: 'ui-dates-with-divider',
  imports: [CommonModule, IntrackFeatureModule, DateWithTimezoneComponent, SvgIconComponent],
  templateUrl: './dates-with-divider.component.html',
  styleUrls: ['./dates-with-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatesWithDividerComponent {
  @Input() label: string;
  @Input() startDate: LocalDate;
  @Input() endDate: LocalDate;

  @Input() arrivalDeviation: string;
  @Input() departureDeviation: string;

  @Input() showWarningIcon: boolean;
  @Input() warningMessage: string;

  dateFormat = DISPLAY_DATE_FORMAT;
  iconNameList = IconNames;
}
